if(document.querySelectorAll(".temp-product").length > 0 && document.querySelectorAll(".block_product-openbox-text-url").length > 0){

let productopenClose = document.querySelector(".block_detail-openpopup-close");
productopenClose.addEventListener("click", (event) => {
	document.querySelector("body").classList.remove("over-hidden-open");
	document.querySelector(".block_open-box-popup").classList.toggle("hidden");
	setTimeout( () => {
		document.querySelector("body").classList.remove("over-hidden");
	}, 10)	
	
})


document.addEventListener('click', function(e) {
	let container = document.querySelector('.block_open-box-popup-inner');
	let container2 = document.querySelector('.block_product-openbox-text-url');
    let container3 = document.querySelector('.block_product-details');
    let container4 = document.querySelector('.block_detail-popup-inner');
	let target = e.target;
		if (!container.contains(target) && !container2.contains(target) && !container3.contains(target)) {
		let isContainerClicked = target.classList.contains('.block_open-box-popup-inner');
		let isDescendantClicked = container.contains(target);
	   if (!isContainerClicked && !isDescendantClicked && !container3.contains(target) && !container2.contains(target) && !container4.contains(target) ) {  
			let kalviyoElements = document.querySelectorAll('.block_open-box-popup');
			kalviyoElements.forEach(function(element) {
				element.classList.add('hidden');     
                document.querySelector("body").classList.remove("over-hidden-open");
			});
		}
	}
});
}
